export const OPTION_BUTTON = 'OPTION_BUTTON'
export const SERVICE_APP_ACTIONS_POPUP_CLOSE = 'SERVICE_APP_ACTIONS_POPUP_CLOSE'
